import React, { useMemo, useState, useCallback } from "react";
import { useAppSelector } from "@/services/hooks";
import CreatePageView from "./CreatePageView";

function CreatePageContainer() {
  const CurrentSite = useAppSelector((s) => s.sites.site);
  const [formSimplePages, setFormSimplePages] = useState(true);

 
  const handleFormType = useCallback((name: string) => {
    const next = name !== "required";
  
    setFormSimplePages((prev) => (prev === next ? prev : next));
  }, []);

  
  const resultNavFooter = useMemo(() => {
    const rp = CurrentSite?.required_pages;
    if (!Array.isArray(rp)) return undefined; 
    if (rp.length === 0) return 0;
    if (rp.length === 1) return 1;
    if (rp.length === 2) return "done";
    return "...";
  }, [CurrentSite]);

  return (
    <CreatePageView
      formSimplePages={formSimplePages}
      resultNavFooter={resultNavFooter}
      onFormType={handleFormType}
      CurrentSite={CurrentSite}
    />
  );
}

export default CreatePageContainer;
